// Clinic Configuration - White-label settings for TaisaCore platform
// This file can be customized for each clinic deployment

const clinicConfig = {
  // Clinic branding
  name: 'Yahalomi',
  nameHebrew: 'יהלומי',

  // Platform branding
  platform: 'TaisaCore',

  // Taglines
  tagline: 'Smart Dental Clinic Management',
  taglineHebrew: 'ניהול חכם למרפאת שיניים',

  // Colors (can be customized per clinic)
  colors: {
    primary: '#7C5CBA',
    accent: '#5BA4A4',
    secondary: '#9F7AEA',
    success: '#48BB78',
    warning: '#ECC94B',
    danger: '#F56565',
  },

  // Contact info
  contact: {
    phone: '+972-XX-XXX-XXXX',
    email: 'info@yahalomi.co.il',
    address: '',
  },

  // Features toggles
  features: {
    showVoiceAgent: true,
    showSMS: true,
    showBooking: true,
    show3DVisualization: false, // Using SVG instead
  },

  // Language settings
  defaultLanguage: 'en', // 'en' or 'he'
  supportedLanguages: ['en', 'he'],
};

export default clinicConfig;
export { clinicConfig };
